import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getPurchaseOrderList = createAsyncThunk(
  "get-purchase-order",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("purchase/order/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const createPurchaseOrder = createAsyncThunk(
  "create-purchase-order",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("purchase/order", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const getByIdPurchaseOrder = createAsyncThunk(
  "edit-purchase-order",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`purchase/order/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const updatePurchaseOrder = createAsyncThunk(
  "update-purchase-order",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/purchase/order/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);
export const managePricePurchaseOrder = createAsyncThunk(
  "update-purchase-order",
  async (data, { dispatch }) => {
    try {
      const response = await axios.put(`/purchase/order/manage-price`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const deletePurchaseOrder = createAsyncThunk(
  "delete-purchase-order",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/purchase/order/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

// PO approve/reject thunks were removed with the Approval column: approval now
// happens on the Pre-Book Order screen, before a pre-order becomes a PO.

export const toggleGodownStatus = createAsyncThunk(
  "toggle-godown-status",
  async ({ id, productIndex }, { dispatch }) => {
    try {
      const response = await axios.put(
        `/purchase/order/toggle-godown-status/${id}`,
        { productIndex },
      );
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

const purchaseOrderSlice = createSlice({
  name: "purchase-order",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPurchaseOrderList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPurchaseOrderList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.purchaseOrderList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getPurchaseOrderList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default purchaseOrderSlice.reducer;
